module.exports = __webpack_public_path__ + "img/39.cb4d4908.png";